export const canReviewTargetRole = (reviewerRole = "tenant", targetRole = "tenant") => {
  if (reviewerRole === "tenant") {
    return targetRole === "landlord" || targetRole === "property_manager";
  }

  if (reviewerRole === "landlord" || reviewerRole === "property_manager") {
    return targetRole === "tenant";
  }

  return false;
};

export const canRoleClaimProperty = (roleValue = "tenant", verificationStatusValue = "") => {
  return (
    roleValue === "landlord" ||
    roleValue === "property_manager" ||
    verificationStatusValue === "landlord_verified" ||
    verificationStatusValue === "property_manager_verified"
  );
};

export const getDefaultProfileStatus = (roleValue = "tenant") => {
  if (roleValue === "landlord") return "units_available";
  if (roleValue === "property_manager") return "leasing_soon";
  return "actively_looking";
};

export const getProfileStatusOptions = (roleValue = "tenant") => {
  if (roleValue === "landlord" || roleValue === "property_manager") {
    return [
      { value: "units_available", label: "Units Available" },
      { value: "leasing_soon", label: "Leasing Soon" },
      { value: "fully_occupied", label: "Fully Occupied" },
      { value: "not_accepting", label: "Not Accepting Applications" },
    ];
  }

  return [
    { value: "actively_looking", label: "Actively Looking" },
    { value: "browsing", label: "Browsing" },
    { value: "already_renting", label: "Already Renting" },
    { value: "not_looking", label: "Not Looking" },
  ];
};

export const getProfileStatusMeta = (statusValue = "") => {
  const map = {
    actively_looking: {
      label: "Actively Looking",
      background: "#dcfce7",
      color: "#166534",
      border: "1px solid #bbf7d0",
    },
    browsing: {
      label: "Browsing",
      background: "#fef3c7",
      color: "#92400e",
      border: "1px solid #fde68a",
    },
    already_renting: {
      label: "Already Renting",
      background: "#dbeafe",
      color: "#1d4ed8",
      border: "1px solid #bfdbfe",
    },
    not_looking: {
      label: "Not Looking",
      background: "#e5e7eb",
      color: "#374151",
      border: "1px solid #d1d5db",
    },
    units_available: {
      label: "Units Available",
      background: "#dcfce7",
      color: "#166534",
      border: "1px solid #bbf7d0",
    },
    leasing_soon: {
      label: "Leasing Soon",
      background: "#e0f2fe",
      color: "#075985",
      border: "1px solid #bae6fd",
    },
    fully_occupied: {
      label: "Fully Occupied",
      background: "#fee2e2",
      color: "#b91c1c",
      border: "1px solid #fecaca",
    },
    not_accepting: {
      label: "Not Accepting Applications",
      background: "#f3f4f6",
      color: "#4b5563",
      border: "1px solid #e5e7eb",
    },
  };

  return map[statusValue] || {
    label: "Status Not Set",
    background: "#eef2f7",
    color: "#475569",
    border: "1px solid #d9e2ec",
  };
};

export const normalizeAreaTags = (value = "") =>
  String(value)
    .split(",")
    .map((item) => item.trim())
    .filter(Boolean);

export const getPublicAreaSummary = (profileData = {}) => {
  const roleValue = profileData?.role || "tenant";
  const areaList = normalizeAreaTags(
    roleValue === "tenant"
      ? profileData?.preferredAreasText || ""
      : profileData?.serviceAreasText || ""
  );

  if (areaList.length) return areaList.join(", ");
  return String(profileData?.city || "").trim();
};

export const matchesAreaFilter = (profileData = {}, areaFilter = "") => {
  const term = String(areaFilter || "").trim().toLowerCase();
  if (!term) return true;

  const areaText = [
    profileData?.city || "",
    profileData?.state || "",
    getPublicAreaSummary(profileData),
    profileData?.preferredAreasText || "",
    profileData?.serviceAreasText || "",
  ]
    .join(" ")
    .toLowerCase();

  return areaText.includes(term);
};